import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button/Button';
import FileTypeMarketing from '../ResourcesSidebar/FileTypeMarketing';
import FileFormatMarketing from '../ResourcesSidebar/FileFormatMarketing';
import { FilterSchema } from '@/components/ResourcesSidebar/ResourcesSidebarHelpers';

const InitialState = {
  fileTypeMarketing: [],
  fileFormatMarketing: [],
};

const FileExplorerMarketingFilters = ({
  filters,
  onFiltersChange,
}: {
  filters: Partial<FilterSchema>;
  onFiltersChange: (filters: Partial<FilterSchema>) => void;
}) => {
  const handleClearAll = () => {
    onFiltersChange(InitialState);
  };

  const handleChange = (key: keyof FilterSchema, value: string[]) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  return (
    <Root>
      <Header>
        <FormattedMessage id="filterBy" defaultMessage="Filter By" />
        <Button
          variant="text"
          customVariant="text-small"
          onClick={handleClearAll}
          aria-label="Clear All Button"
        >
          <FormattedMessage
            id="clearAll"
            defaultMessage="Clear All"
          />
        </Button>
      </Header>
      <FileTypeMarketing
        value={
          filters.fileTypeMarketing || InitialState.fileTypeMarketing
        }
        onChange={(value) => handleChange('fileTypeMarketing', value)}
      />
      <FileFormatMarketing
        value={
          filters.fileFormatMarketing ||
          InitialState.fileFormatMarketing
        }
        onChange={(value) =>
          handleChange('fileFormatMarketing', value)
        }
      />
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  width: 240,
  height: '100%',
  maxHeight: '400px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.radii.xs,
  backgroundColor: theme.palette.white,
  padding: '16px 12px',
  boxShadow:
    '0px 10px 32px -4px #1319271A, 0px 6px 14px -6px #1319271F',
}));

const Header = styled('div')(() => ({
  fontSize: 16,
  lineHeight: '24px',
  fontWeight: 500,
  padding: '4px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export default FileExplorerMarketingFilters;
